import React from 'react';

function CardImageAndCount({ imageURL, count, text, width = '23' }) {
  return (
    <li>
      <span>
        <img
          src={imageURL}
          className=''
          width={width}
          alt='ImageChange'
        />
      </span>
      <span>{count}</span>
      <div className='tootip_box'>{text}</div>
    </li>
  );
}

export default CardImageAndCount;



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/CardImageAndCount.jsx